import './product.scss';
import { setupLayout } from '../Shared/layout';
import * as $ from 'jquery';
import 'owl.carousel/dist/owl.carousel';

setupLayout();

$("#partsCarousel").owlCarousel({
    dots: false,
    nav: true,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1
        },
        421: {
            items: 2
        },
        769: {
            items: 3
        },
        1025: {
            items: 4
        },
        1365: {
            items: 5
        }
    }
});

$("#searchMoreButton").click(function () {
    var elem = $(this).next();
    elem.slideDown();
    setTimeout(function () {
        elem.children().focus();
    }, 1000)
});

document
    .querySelector(".sidebarButton")
    .addEventListener("click", function () {
        document.querySelector(".categoryBox").classList.add("active");
        document.querySelector(".categoryBackgroundCover").classList.add("active");
    });

document.querySelector(".quitBtn").addEventListener("click", function () {
    document.querySelector(".categoryBox").classList.remove("active");
    document.querySelector(".categoryBackgroundCover").classList.remove("active");
});

document
    .querySelector(".categoryBackgroundCover")
    .addEventListener("click", function () {
        document.querySelector(".categoryBox").classList.remove("active");
        document.querySelector(".categoryBackgroundCover").classList.remove("active");
    });

